import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "h5"
}
const _hoisted_2 = { class: "accordianList" }
const _hoisted_3 = { class: "inner" }
const _hoisted_4 = { class: "main" }
const _hoisted_5 = { class: "col mobile" }
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "content" }
const _hoisted_8 = { class: "actions" }
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "keyInfoWrapper" }
const _hoisted_12 = { class: "h4 keyInfoTitle" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = {
  key: 0,
  class: "col desktop"
}
const _hoisted_15 = { class: "info" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = { class: "col" }
const _hoisted_18 = { class: "ports" }
const _hoisted_19 = {
  key: 0,
  class: "portlist"
}
const _hoisted_20 = ["href"]
const _hoisted_21 = {
  key: 1,
  class: "loadingList"
}
const _hoisted_22 = { class: "col" }
const _hoisted_23 = { class: "vessels" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = ["href"]
const _hoisted_26 = {
  key: 1,
  class: "loadingList"
}

import { Skeletor } from 'vue-skeletor';
import { RoutesServedType } from '../../types/RenderTypes';
import { Card, Icon } from '../../Atoms';
import {
  Accordian, PortList, IconText, RouteSearchMap,
} from '../../Molecules';
import { ticketingUrl } from '../../envVariables';
import 'vue-skeletor/dist/vue-skeletor.css';


export default /*@__PURE__*/_defineComponent({
  __name: 'RoutesServed',
  props: {
    routes: {},
    isLoading: { type: Boolean },
    showDesktopView: { type: Boolean },
    expandFirstItem: { type: Boolean },
    isInteractiveMapView: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["routesServed", {desktopView: _ctx.showDesktopView}])
  }, [
    (!_ctx.showDesktopView)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_1, _toDisplayString(_ctx.$t('Routes served')), 1))
      : _createCommentVNode("", true),
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.routes, (route, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: `${route.routeCode}-${index}`
        }, [
          _createVNode(_unref(Accordian), {
            "panel-id": `${route.routeCode}-panel`,
            "control-id": `${route.routeCode}-control`,
            "is-expanded": _ctx.expandFirstItem ? index === 0 : false,
            "header-label": route.portList.map(p => p.name).join(' to ')
          }, {
            header: _withCtx(() => [
              _createVNode(_unref(Card), null, {
                default: _withCtx(() => [
                  (!_ctx.isInteractiveMapView)
                    ? (_openBlock(), _createBlock(_unref(Icon), {
                        key: 0,
                        "icon-name": "ferries"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(PortList), {
                    ports: route.portList,
                    "show-port-location": true,
                    "is-loading": _ctx.isLoading
                  }, null, 8, ["ports", "is-loading"])
                ]),
                _: 2
              }, 1024)
            ]),
            content: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    (!_ctx.isLoading)
                      ? (_openBlock(), _createBlock(_unref(RouteSearchMap), {
                          key: 0,
                          "is-static-map": true,
                          routes: route.routeMap,
                          ports: route.mapPort
                        }, null, 8, ["routes", "ports"]))
                      : (_ctx.isLoading)
                        ? (_openBlock(), _createBlock(_unref(Skeletor), {
                            key: 1,
                            class: "mapSkeleton"
                          }))
                        : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        (_ctx.showDesktopView)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: _unref(ticketingUrl),
                              class: "button"
                            }, _toDisplayString(_ctx.$t('Buy tickets')), 9, _hoisted_9))
                          : _createCommentVNode("", true),
                        (route.portList.length <= 2)
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: route.timetableLink,
                              class: "viewTimetableBtn button"
                            }, _toDisplayString(_ctx.$t('View timetable')), 9, _hoisted_10))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("h3", _hoisted_12, _toDisplayString(_ctx.$t('Key information')), 1),
                        (!_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: "keyInfo",
                              innerHTML: route.keyInformation
                            }, null, 8, _hoisted_13))
                          : (_ctx.isLoading)
                            ? (_openBlock(), _createBlock(_unref(Skeletor), {
                                key: 1,
                                class: "keyInfoSkeleton",
                                height: "50",
                                width: "400"
                              }))
                            : _createCommentVNode("", true)
                      ])
                    ])
                  ]),
                  (_ctx.showDesktopView)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                        (!_ctx.isLoading)
                          ? (_openBlock(), _createBlock(_unref(RouteSearchMap), {
                              key: 0,
                              "is-static-map": true,
                              routes: route.routeMap,
                              ports: route.mapPort
                            }, null, 8, ["routes", "ports"]))
                          : (_ctx.isLoading)
                            ? (_openBlock(), _createBlock(_unref(Skeletor), {
                                key: 1,
                                class: "mapSkeleton"
                              }))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("h4", null, _toDisplayString(_ctx.$t('More route information')), 1),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('Ports')), 1),
                        (!_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.portList, (port, index) => {
                                return (_openBlock(), _createElementBlock("ul", {
                                  key: `${port.name}-${index}`
                                }, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "ctaLink",
                                      href: port.portUrl
                                    }, [
                                      _createVNode(_unref(IconText), {
                                        text: port.name,
                                        "icon-name": "anchor"
                                      }, null, 8, ["text"])
                                    ], 8, _hoisted_20)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("ul", null, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
                                    return _createElementVNode("li", { key: index }, [
                                      _createVNode(_unref(Skeletor), {
                                        height: "30",
                                        width: "200"
                                      })
                                    ])
                                  }), 64))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("h5", null, _toDisplayString(_ctx.$t('Ferries')), 1),
                        (!_ctx.isLoading)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(route.vesselList, (vessel, index) => {
                                return (_openBlock(), _createElementBlock("ul", {
                                  key: `${vessel.name}-${index}`
                                }, [
                                  _createElementVNode("li", null, [
                                    _createElementVNode("a", {
                                      class: "ctaLink",
                                      href: vessel.vesselUrl
                                    }, [
                                      _createVNode(_unref(IconText), {
                                        text: vessel.name,
                                        "icon-name": "ferry"
                                      }, null, 8, ["text"])
                                    ], 8, _hoisted_25)
                                  ])
                                ]))
                              }), 128))
                            ]))
                          : (_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                _createElementVNode("ul", null, [
                                  (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (index) => {
                                    return _createElementVNode("li", { key: index }, [
                                      _createVNode(_unref(Skeletor), {
                                        height: "30",
                                        width: "200"
                                      })
                                    ])
                                  }), 64))
                                ])
                              ]))
                            : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ])
              ])
            ]),
            _: 2
          }, 1032, ["panel-id", "control-id", "is-expanded", "header-label"])
        ]))
      }), 128))
    ])
  ], 2))
}
}

})